/* eslint-disable prettier/prettier */
import React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import PropTypes from "prop-types";

const styles = {
  container: {
    my: 2,
    mr: 2,
    minWidth: 150,
    padding: 0,
    width: "100%",
  },
  selectOption: {
    "&.Mui-selected, &.Mui-selected:hover": {
      backgroundColor: "rgba(85, 108, 214, 0.4)",
    },
  },
};

function DropDownSelect({
  title,
  selectOptions,
  name,
  value,
  setValue,
  disabled,
  className,
  style,
  multiple,
}) {
  return (
    <FormControl
      sx={{ ...styles.container, ...style }}
      size="small"
      className={className}
    >
      <InputLabel id="demo-simple-select-helper-label">{title}</InputLabel>
      <Select
        labelId="demo-select-small"
        id="demo-select-small"
        name={name}
        value={value}
        label="Age"
        multiple={multiple}
        disabled={disabled}
        style={styles.select}
        // sx={{padding: '4px'}}
        onChange={(event) => setValue(event.target.value)}
      >
        {selectOptions.map((option) => (
          <MenuItem
            sx={styles.selectOption}
            value={option.value}
            key={option.value}
          >
            {option.entityTitle}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

const propTypes = {
  title: PropTypes.string,
  selectOptions: PropTypes.arrayOf(PropTypes.element).isRequired,
  value: PropTypes.string,
  setValue: PropTypes.func,
  disabled: PropTypes.bool,
  multiple: PropTypes.bool,
  style: PropTypes.objectOf(),
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
};

const defaultProps = {
  title: "",
  value: "",
  setValue: () => {},
  disabled: false,
  multiple: false,
  style: {},
  className: "",
};

DropDownSelect.propTypes = propTypes;
DropDownSelect.defaultProps = defaultProps;

export default DropDownSelect;
